import { IAddressRepository } from '../../application/ports/repositories/IAddressRepository';
import store from 'store';
import { setHouseAddress } from '../../frameworks_drivers/redux/reducers/onboardingInformation/onboardingInformationSlice';
import { Address } from '../../entities/model/Address';

export class ReduxAddressRepository implements IAddressRepository {
  getHouseAddress(): Address {
    const { street, houseNumber, zip, city } = store.getState().onboardingInfo.houseAddress;
    return { street, houseNumber, zip, city };
  }

  saveHouseAddress(address: Address) {
    store.dispatch(setHouseAddress(address));
  }

  getInvoiceAddress(): Address {
    const { street, houseNumber, zip, city } = store.getState().onboardingInfo.invoiceAddress;
    return { street, houseNumber, zip, city };
  }
}
